export class LogEventStrings {

    public static SUCCESSFUL_SETUP: string = "Customer has successfully configured his account for online access.";
    public static SUCCESSFUL_LOGIN: string = "Customer successfully logged in.";
    public static UNSUCCESSFUL_LOGIN: string = "Customer Login/password match failed.";    
    public static CUSTOMER_VIEWED_STATEMENT: string = "Customer viewed his/her monthly statement. {0}";
    public static CUSTOMER_DOWNLOADED_STATEMENT: string = "Customer downloaded his/her monthly statement. {0}";
    public static CUSTOMER_PRINTED_STATEMENT: string = "Customer printed his/her monthly statement.";
    public static CUSTOMER_VIEWED_CONFIRMATION: string = "Customer viewed his/her trade confirmation. {0}";
    public static CUSTOMER_DOWNLOADED_CONFIRMATION: string = "Customer downloaded his/her trade confirmation. {0}";
    public static CUSTOMER_PRINTED_CONFIRMATION: string = "Customer printed his/her trade confirmation.";
    public static CUSTOMER_VIEWED_SUMMARY: string = "Customer viewed his/her year end summary. {0}";
    public static CUSTOMER_DOWNLOADED_SUMMARY: string = "Customer downloaded his/her year end summary. {0}";
    public static CUSTOMER_PRINTED_SUMMARY: string = "Customer printed his/her year end summary.";
    public static CUSTOMER_CHANGED_PASSWORD: string = "Customer changed his/her password.";
    public static CUSTOMER_CHANGED_USERID: string = "Customer changed his/her user ID.";
    public static CUSTOMER_ACCESS_DISABLED: string = "Customer's account access is disabled.";
    public static CUSTOMER_TEMP_PASSWORD_EXPIRED: string = "Customer's temporary password has expired.";

}
